import { combineReducers } from "redux";
import byId from "./byId";
import isFetchingAll from "./isFetchingAll";

import { TemplateMetadataStoreSlice } from "../../types";

export default combineReducers<TemplateMetadataStoreSlice>({
  byId,
  isFetchingAll,
  visibleOverviewIds: (ids = []) => ids,
});
